import { Helmet } from "react-helmet-async";
import logoLight from "@/assets/masonry-pro-logo-3.webp";

const PHONE_DISPLAY = "(973) 725-2395";
const PHONE_TEL = "+19737252395";
const CANONICAL = "https://masonry-pro.com/lp/backyard-bundle/thank-you";

const styles = `
.byty{
  --base:#15120F;
  --surface:#211C17;
  --accent: hsl(42 60% 62%);
  --text:#F2ECE3;
  --muted:#9A9088;
  --line:rgba(242,236,227,.12);
  background:var(--base);
  color:var(--text);
  font-family:"Inter",system-ui,sans-serif;
  min-height:100vh;
  display:flex;
  flex-direction:column;
  -webkit-font-smoothing:antialiased;
}
.byty *{box-sizing:border-box}
.byty h1{font-family:"Archivo",system-ui,sans-serif;letter-spacing:-.02em;line-height:1.04;margin:0}
.byty p{margin:0}
.byty a{color:inherit}
.byty img{display:block;max-width:100%}
.byty .byty-head{border-bottom:1px solid var(--line);padding:18px 22px;display:flex;justify-content:center}
.byty .byty-logo{height:42px;width:auto}
.byty .byty-main{flex:1;display:flex;align-items:center;justify-content:center;padding:60px 22px}
.byty .byty-card{max-width:680px;width:100%;text-align:center}
.byty .byty-badge{display:inline-flex;align-items:center;justify-content:center;width:64px;height:64px;border-radius:999px;background:rgba(212,179,109,.14);color:var(--accent);margin:0 auto 24px;border:1px solid rgba(212,179,109,.35)}
.byty h1{font-size:clamp(34px,6.5vw,56px);font-weight:900;margin-bottom:18px}
.byty .byty-lead{font-size:clamp(17px,2.2vw,20px);color:#d8d0c5;margin-bottom:28px;line-height:1.55}
.byty .byty-call{font-size:17px;color:var(--text);margin-bottom:40px}
.byty .byty-call a{color:var(--accent);font-family:"Archivo",sans-serif;font-weight:800;letter-spacing:.01em;text-decoration:none;border-bottom:1px solid rgba(212,179,109,.4)}
.byty .byty-call a:hover{border-bottom-color:var(--accent)}
.byty .byty-secondary{font-size:14px;color:var(--muted)}
.byty .byty-secondary a{color:var(--muted);text-decoration:underline;text-underline-offset:3px}
.byty .byty-secondary a:hover{color:var(--accent)}
.byty .byty-foot{padding:22px;text-align:center;color:var(--muted);font-size:12px;border-top:1px solid var(--line)}
`;

export default function BackyardBundleThankYou() {
  return (
    <div className="byty">
      <Helmet>
        <title>Thanks — We've Got Your Info | Masonry Pro</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={CANONICAL} />
        <style>{styles}</style>
      </Helmet>

      <header className="byty-head">
        <img src={logoLight} alt="Masonry Pro" className="byty-logo" width={180} height={42} />
      </header>

      <main className="byty-main">
        <div className="byty-card">
          <div className="byty-badge" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h1>Thanks. We've got your info.</h1>
          <p className="byty-lead">
            We'll review your project details and reach out within one business day to set up your free on-site visit.
          </p>
          <p className="byty-call">
            Want to talk sooner? Call us at <a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>
          </p>
          <p className="byty-secondary">
            In the meantime, <a href="https://masonry-pro.com/gallery">see more of our work</a>.
          </p>
        </div>
      </main>

      <footer className="byty-foot">
        © {new Date().getFullYear()} Masonry Pro · NJ HIC License #13VH06777200
      </footer>
    </div>
  );
}